









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BookingCandidateListFilterForm from './List/BookingCandidateListFilterForm.vue';
import BookingCandidateListFilterChip from './List/BookingCandidateListFilterChip.vue';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { NEGATIVE_RULE_FLAGS } from '@/constants/questionnaire_answer';
import QDownloadBtn from '@/components/QDownloadBtn.vue';
import { BOOKING_PURPOSES } from '../../../constants/booking';
import { jsonToQueryString, parseNumericStrings } from '@/utils/utils';

@Component({
  components: {
    BookingCandidateListFilterForm,
    BookingCandidateListFilterChip,
    QDownloadBtn,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('UserPreference', {
      userPreference: 'single',
    }),
  },
})
export default class BookingCandidateList extends Vue {
  // candidate State
  business!: Model;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  negativeRuleFlags = NEGATIVE_RULE_FLAGS;
  bookingPurposes = BOOKING_PURPOSES;
  userPreference!: Model;

  // Data
  options = {
    page: 1,
    itemsPerPage: 10,
    candidateName: null,
    bookingGid: null,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
    statuses: [],
  };
  reload = 0;
  headers = [
    { text: 'Booking ID', value: 'booking.gid' },
    {
      text: 'Risk Profile',
      value: 'booking.risk_profile.custom_job_role_name',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Booking Type',
      value: 'booking.purpose',
      align: 'left',
      sortable: false,
    },
    { text: 'Candidate', value: 'first_name', align: 'left', sortable: false },
    {
      text: 'Status',
      value: 'status',
      align: 'left',
      sortable: false,
      width: '15%',
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'left',
      sortable: false,
      width: '15%',
      cellClass: 'row-click-stop',
    },
  ];

  showTips = false;

  isMounted = false;

  resetPage = false;

  beforeMount() {
    this.options = {
      ...this.options,
      ...parseNumericStrings(this.$route.query),
    };
    this.isMounted = true;
  }

  @Watch('options', { immediate: false })
  watchOptions(newVal, oldVal) {
    this.resetPage =
      oldVal.query != newVal.query ||
      oldVal.statuses != newVal.statuses ||
      oldVal.candidateName != newVal.candidateName ||
      oldVal.bookingGid != newVal.bookingGid;

    this.options.page = this.resetPage ? 1 : this.options.page;

    history.pushState(
      {},
      '',
      this.$route.path +
        '?' +
        jsonToQueryString({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          candidateName: this.options.candidateName,
          bookingGid: this.options.bookingGid,
          query: this.options.query,
          orderBy: this.options.orderBy,
          orderByDirection: this.options.orderByDirection,
          statuses: this.options.statuses,
        })
    );
  }

  isHealthCheck(booking) {
    return (
      booking.purpose &&
      booking.purpose ===
        this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    );
  }

  /**
   * Show the individual status if one of following conditions is true:
   * - the booking is general health check
   * - the userPreference does not exist (It means showing the status by default)
   * - ghc_booking_candidate_status_enabled in userPreference is true
   */
  showStatus(bookingCandidate) {
    return (
      !this.isHealthCheck(bookingCandidate.booking) ||
      !this.userPreference ||
      this.userPreference?.booking_settings
        ?.ghc_booking_candidate_status_enabled
    );
  }

  // Methods
  handleFetch() {
    const options = {
      params: {
        search_name: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        candidate_name: this.options.candidateName,
        booking_gid: this.options.bookingGid,
        expand: [
          'booking',
          'booking.questionnaire',
          'booking.request_business',
          'booking.risk_profile',
          'questionnaire_answer.recommendation',
        ],
        business_oid: this.business.object_id,
      },
    };
    return this.$store.dispatch('BookingCandidate/fetchList', options);
  }

  handleClick(item) {
    const routeData = this.$router.resolve({
      name: 'business-booking-read',
      params: {
        bookingOid: item.booking.object_id,
      },
    });
    window.open(routeData.href, '_blank');
  }

  name(item) {
    if (!item.first_name && !item.last_name) {
      return null;
    }
    return (item.first_name ?? '') + ' ' + (item.last_name ?? '');
  }

  toDownloadReport(item) {
    return this.$store
      .dispatch('BookingCandidate/fetch', item.object_id)
      .then(async (response) => {
        const bookingCandidate = response.data.data;

        return await this.$store
          .dispatch(
            'QuestionnaireAnswer/downloadReport',
            bookingCandidate.questionnaire_answer.object_id
          )
          .then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Quescreen Report - ' + this.name(item);
            link.click();
          });
      });
  }

  getNegativeRuleFlagText(recommendation) {
    if (recommendation.level) {
      switch (recommendation.level) {
        case 'LEVEL_SUITABLE':
        case 'LEVEL_FURTHER_REVIEW':
        case 'LEVEL_NOT_SUITABLE':
        default:
          return '';
      }
    }

    return (
      '-' + this.negativeRuleFlags[recommendation.warning_level].text + ' Risk'
    );
  }

  getNegativeRuleFlagColor(recommendation) {
    if (recommendation.level) {
      switch (recommendation.level) {
        case 'LEVEL_SUITABLE':
          return this.negativeRuleFlags[11].color;
        case 'LEVEL_FURTHER_REVIEW':
          return this.negativeRuleFlags[13].color;
        case 'LEVEL_NOT_SUITABLE':
          return this.negativeRuleFlags[15].color;
        default:
          return this.negativeRuleFlags[11].color;
      }
    }

    return this.negativeRuleFlags[recommendation.warning_level].color;
  }

  toReport(item) {
    const routeData = this.$router.resolve({
      name: 'business-booking-candidate-report',
      params: {
        bookingOid: item.booking.object_id as string,
        questionnaireAnswerOid: item.questionnaire_answer.object_id as string,
      },
    });
    window.open(routeData.href, '_blank');
  }
}
